import { lazy } from 'react';
const FATransactions = lazy(() => import('./FATransactions'));

const FATransactionsRoutes = [
  {
    path: '/fatransactions',
    component: FATransactions
  }
];

export default FATransactionsRoutes;
